import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const CLIENT_INFO_SCHEMA = Object.freeze({
  ID: '',
  NAME: '',
});
export const RECORD = generateSchema(CLIENT_INFO_SCHEMA);
export const KEYS: any = generateKeys(CLIENT_INFO_SCHEMA);

export class ClientInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }
}
